/**
 * Union and interface members, for InMemoryCache.
 *
 * Apollo Client 3 dropped heuristic fragment matching. Without this map the
 * cache cannot tell that `Media` satisfies `... on Media` inside a
 * `ContentFeedItem` selection, so every field inside an inline fragment is
 * silently dropped on read -- the query returns `__typename` and nothing else,
 * with no error. mi6 has no codegen, so this is generated by hand:
 *
 *   node -e "
 *     const s = require('../user-api/graphql-schema.json')
 *     const types = (s.data || s).__schema.types
 *     const map = {}
 *     types
 *       .filter(t => (t.kind === 'UNION' || t.kind === 'INTERFACE') && t.possibleTypes?.length)
 *       .sort((a, b) => a.name.localeCompare(b.name))
 *       .forEach(t => { map[t.name] = t.possibleTypes.map(p => p.name).sort() })
 *     console.log(JSON.stringify(map, null, 2))
 *   "
 *
 * Re-run it when a union or interface changes in user-api. A stale entry fails
 * the same quiet way, so if fields ever go missing from a union selection,
 * check here first.
 */
const possibleTypes: Record<string, string[]> = {
  ActivityResultData: [
    'ContentShare',
    'DirectConnection',
    'Doclet',
    'Document',
    'Event',
    'MemberConnection',
    'Message',
    'Person',
    'PollVote',
    'Post',
    'RSVPUpdate',
    'SearchActivity',
    'TopicFilter',
    'UserMediaDownload',
    'UserMediaState'
  ],
  BookmarkObject: ['Doclet', 'Document', 'Event', 'Media', 'Post'],
  ConnectionObject: ['Event', 'Group', 'Person'],
  ContentFeedItem: ['Doclet', 'Document', 'Media'],
  ContentTopicEntity: ['Doclet', 'Document', 'Event', 'Media', 'Post'],
  FormQuestionMapEntity: ['Question', 'QuestionGroup'],
  NotificationEmailObject: ['Message', 'Post', 'Room'],
  NotificationObject: ['Event', 'Message', 'Person', 'Poll', 'Post', 'Room'],
  PersonaEntity: ['Company', 'Event', 'Person', 'Program'],
  PersonProfilePicture: ['Image', 'ProfilePicture'],
  Publishable: ['Document', 'Media'],
  PulseContent: ['PulseDoclet', 'PulseDocument', 'PulseMedia'],
  QuestionGroupEntityMapEntity: ['Question', 'QuestionGroup'],
  RSVPEvent: ['DeletedEvent', 'Event'],
  SearchInnovationObject: [
    'CallForSubmission',
    'Company',
    'CompanyProfile',
    'InnovationSubmission'
  ],
  SearchObject: [
    'Company',
    'Doclet',
    'Document',
    'Event',
    'EventAttendee',
    'Media',
    'MemberProfile',
    'Person',
    'Post'
  ],
  SharedItemData: ['Document', 'UserMediaState']
}

export default possibleTypes
